import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'ui-components/components/input';
import { testId } from 'ui-components/services/testid-service';
import style from './style.module.less';

const ProductAutoComplete = ({ value, field, index, searchResults, showSearchResults, onAutoCompleteChange, hasError }) => {
  return (
    <div className={style['search-results']}>
      {searchResults.length > 0 && showSearchResults(field, index)}
      <Input
        className={style['input-without-label']}
        {...testId(`${field}-${index}-new-order-item-input`)}
        hasError={field !== 'sku' && hasError && value.length === 0}
        label=''
        onChange={(val) => onAutoCompleteChange(val, field, index)}
        value={value || ''}
      />
    </div>
  );
};

ProductAutoComplete.propTypes = {
  value: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  searchResults: PropTypes.array.isRequired,
  showSearchResults: PropTypes.func.isRequired,
  onAutoCompleteChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
};

export default ProductAutoComplete;
